import React, {useContext, useEffect} from 'react'
import _ from 'lodash/fp'
import styled from 'styled-components/macro'
import {DEVICE, DISK} from "../enums/UploaderStepsManagement";
// import {DragDropContext, Droppable} from "react-beautiful-dnd";
import {DragDropContext, Droppable} from "@hello-pangea/dnd";
import {isOtherKnowExtension} from "../dicom/FileParser";
import {Pathology, Radiology} from "../enums/RecordClass";
import {_s, getColor} from "@startlibs/utils";
import {isMinified} from "./FileinputBox";
import {AddButton} from "./styled/UploaderStyled";
import {UploaderConfigContext} from "../service/UploaderConfigContext";
import {RecordGroup} from "./RecordGroup";
import {useDoAction} from "../service/hooks/useDoAction";
import {GroupAction} from "../service/GroupAction";
import {useUIDataSelector} from "../service/hooks/useUIDataSelector";
import {useRecordsSelector} from "../service/hooks/useRecords";
import {getItemPersistedUID, getRowsForRecords, getRowsForRecordsStatic} from "../service/utils/recordUtils";
import { desaturate, lighten } from 'polished';
import {FormattedMessage} from "react-intl";

styled
const isOfRecordClass = (recordClass) => (attachment) =>
  attachment?.recordClass === recordClass
// let css = "background: #eff4f7; margin:-0.5rem; margin-top: 4px;margin: 0.5rem 0rem; border-radius: 8px;";
let css = `background: ${props => desaturate(0.65, lighten(0.545, getColor('main')(props)))}; margin:-0.5rem; margin-top: 4px;margin: 0.5rem 0rem; border-radius: 8px;`;
let cssBorder = css + "border: 1px solid lightgray;";

export const Records = () => {
  const {
    mode,
    setNotification,
    allowReorder,
    canAddGroup,
    disabled,
    showHiddenRecords
  } = useContext(UploaderConfigContext)
  const doAction = useDoAction()
  const recordGroups = useUIDataSelector('groups')
  const recordKeys = useRecordsSelector(_.map(getItemPersistedUID))
  const [hasIdentifiedFiles,hasOnlyKnownExtensions,hasFilesInMode] = useRecordsSelector(
  isMinified(mode)
     ? _.flow(
      getRowsForRecordsStatic,
      rows => [
        !!rows.find(item => item.mode === mode && !isOtherKnowExtension(item) && !isOfRecordClass(Pathology)(item) && !isOfRecordClass(Radiology)(item)),
        !!rows.find(item => item.mode === mode && isOtherKnowExtension(item) && !isOfRecordClass(Pathology)(item) && !isOfRecordClass(Radiology)(item)),
        !!rows.find((item) => item.mode === mode)
      ]
    )
    : _.constant([])
  )
  const addGroup = () => doAction(GroupAction.AddGroup)

  const onDragEnd = ({source, destination, ...rest}) => {
    if (!destination) {
      return
    }
    if ((destination.droppableId === "notclass") && (rest?.draggableId === "NonCompliantDicom")) {
      setNotification({
        type: "alert",
        timeout: 0,
        msg: (close) => <span><FormattedMessage
          defaultMessage="It is not possible to move NonCompliantDicoms to Hidden Files"
          description="Uploader, invalid record move error message"
        /></span>
      })
      return
    }
    if (source.droppableId === "board") {
      doAction(GroupAction.UpdateGroups, _s.moveElement(source.index, destination.index))
    } else {
      doAction(GroupAction.MoveRecord, source, destination)
    }
  }

  
  const DragDropContextMemoized = React.useMemo(() => DragDropContext, [])

  return <>
    <DragDropContextMemoized onDragEnd={onDragEnd}>
    {/* <DragDropContext  onDragEnd={onDragEnd}> */}
      {(mode == DISK || mode == DEVICE)
        ? // DEVICE OR DISK
        <>
          {isMinified(mode) && hasIdentifiedFiles &&
            <h4 css="font-size: 14px;margin-top: 1rem;"><FormattedMessage
              defaultMessage="We found the following medical records: "
              description="Uploader, medical records found message"
            /></h4>}
          <Droppable
            droppableId="board"
            type="GROUP"
          >
            {(provided) => (
              <>
                <div ref={provided.innerRef} {...provided.droppableProps}
                     css={isMinified(mode)
                       ? hasOnlyKnownExtensions
                         ? cssBorder
                         : css
                       : "margin:-0.5rem"}>
                  {recordGroups.filter(g => g.id !== 'notclass').map((group, index) => (
                    <RecordGroup key={group.id} index={index} group={group}/>
                  ))}
                  {provided.placeholder}
                </div>
                {/*This div below is the separated notclass item*/}
                <div>
                  {recordGroups.filter(g => g.id === 'notclass').map((group, index) => (
                    <RecordGroup key={group.id} index={index} group={group}/>
                  ))}
                </div>
              </>
            )}
          </Droppable>
        </>
        : // NORMAL
        <Droppable
          droppableId="board"
          type="GROUP"
        >
          
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}
                 css={isMinified(mode) ? hasFilesInMode ? cssBorder : css : "margin:-0.5rem"}>
              {/* {recordGroups.map((group, index) => ( */}
              {recordGroups.filter(showHiddenRecords ? g => true : g => g.id !== 'notclass').map((group, index) => (
                <RecordGroup key={group.id} index={index} group={group}/>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      }
    {/* </DragDropContext> */}
    </DragDropContextMemoized>

    {
      allowReorder && canAddGroup && !disabled && (recordKeys.length > 0 || recordGroups.length > 1) &&
      <AddButton css="margin-top:2rem;" onClick={addGroup}><FormattedMessage
        defaultMessage="Add record group"
        description="Uploader, add record group button"
      /></AddButton>
    }
  </>
}